import { createApiRef } from "@backstage/core-plugin-api";
import { WebsiteStats, WebsitePageviews, WebsiteMetrics, WebsiteMetricsEventsSeries } from "../types";

export interface UmamiAnalyticsApi {
    getWebsiteStats(params: {
        websiteId: string;
        startDate: string;
        endDate: string;
    }) : Promise<WebsiteStats>

    getWebsitePageviews(params: {
        websiteId: string;
        startDate: string;
        endDate: string;
        unit?: 'hour' | 'day' | 'month';
        timezone?: string;
    }): Promise<WebsitePageviews>;

    getWebsiteMetrics(params: {
        websiteId: string;
        startDate: string;
        endDate: string;
        type: 'url' | 'referrer' | 'browser' | 'os' | 'device' | 'country' | 'event';
        limit?: number;
    }): Promise<WebsiteMetrics>

    getWebsiteEventSeries(params: {
        websiteId: string;
        startDate: string;
        endDate: string;
        unit?: 'hour' | 'day' | 'month' | 'year';
        timezone?: string;
    }): Promise<WebsiteMetricsEventsSeries>
}

export const umamiAnalyticsApiRef = createApiRef<UmamiAnalyticsApi>({
    id: 'plugin.umami-analytics.api'
})
